import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header-body" }
const _hoisted_3 = { class: "row align-items-center" }
const _hoisted_4 = { class: "col-auto" }
const _hoisted_5 = { class: "header-title text-truncate" }
const _hoisted_6 = { class: "row align-items-center" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = { class: "nav nav-tabs nav-overflow header-tabs" }
const _hoisted_9 = ["onClick", "id"]
const _hoisted_10 = {
  key: 0,
  class: "badge rounded-pill text-bg-secondary-subtle"
}

import { ref } from "vue";
import router from "@/presentation/router";

export type HeaderProps = {
  title: string;
  tabs?: HeaderTab[];
  offset?: string;
  goBackConfig?: {
    name: string;
    params?: any;
  };
};

export type HeaderTab = {
  id: string;
  title: string;
  count?: number;
  active: boolean;
  to: string;
  params: any;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'Header',
  props: {
    title: { default: "" },
    tabs: { default: () => ([]) },
    offset: { default: "auto" },
    goBackConfig: { default: null }
  },
  setup(__props: any) {

// import { HeaderProps, HeaderTab } from "@/types";

const tabsArr = ref(__props.tabs);

const onChangeTab = (tab: HeaderTab) => {
  tabsArr.value = tabsArr.value.map((elem: HeaderTab) => ({
    ...elem,
    active: tab.id === elem.id,
  }));
  const routeConfig: any = { name: tab.to };
  if (tab.params) routeConfig["params"] = tab.params;
  router.push(routeConfig);
};

const handleGoBack = () => {
  if (__props.goBackConfig) router.push(__props.goBackConfig);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.goBackConfig)
            ? (_openBlock(), _createElementBlock("h6", {
                key: 0,
                class: "header-pretitle text-primary cursor-pointer",
                onClick: handleGoBack
              }, _cache[0] || (_cache[0] = [
                _createElementVNode("i", { class: "fa-solid fa-arrow-left" }, null, -1),
                _createTextVNode(" Voltar ")
              ])))
            : _createCommentVNode("", true),
          _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.title), 1)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["col header-right-content", `offset-${_ctx.offset}`])
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("ul", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabsArr.value, (tab, index) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "nav-item cursor-pointer",
                key: index
              }, [
                _createElementVNode("a", {
                  onClick: _withModifiers(($event: any) => (onChangeTab(tab)), ["prevent"]),
                  class: _normalizeClass(["nav-link text-nowrap", { active: tab.active }]),
                  id: `${tab.id}_tab`
                }, [
                  _createTextVNode(_toDisplayString(tab.title) + " ", 1),
                  (tab.count)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(tab.count), 1))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_9)
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}
}

})